import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

export const COPY_MATRIX_STOCK_DIALOG_MESSAGE_ID = 'copy-matrix-stock-dialog-message';

@Component({
  selector: 'app-copy-matrix-stock-dialog',
  standalone: true,
  imports: [
    TranslateModule,

    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
  ],
  templateUrl: './copy-matrix-stock-dialog.component.html',
  styleUrl: './copy-matrix-stock-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyMatrixStockDialogComponent {
  private readonly _dialogRef = inject<MatDialogRef<CopyMatrixStockDialogComponent, boolean>>(MatDialogRef);

  protected readonly messageId = COPY_MATRIX_STOCK_DIALOG_MESSAGE_ID;

  choose(copyMatrixStock: boolean): void {
    this._dialogRef.close(copyMatrixStock);
  }
}
